module.exports = __webpack_public_path__ + "477f436e2a2e6ced7ab2d88ce8663a4a.MP3";